import { useContext } from "react";
import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import ModalContractsListagem from "./children/ModalContractsListagem";
import {
  TemplateContractsContext,
  TemplateContractsContextProvider,
} from "./contexts/ContractsContext";
import { GlobalVariables } from "../../../GlobalVariables";

function View({ location }) {
  const { mainLoading } = useContext(TemplateContractsContext);
  return (
    <>
      <Loading open={mainLoading} />
      <HeaderModule
        title="CADASTRO DE CONTRATOS DE SERVIÇOS"
        videoId={GlobalVariables.screenVideosIds.cadastroGeradorContratos}
      />
      <ModalContractsListagem />
    </>
  );
}

const ContractsList = ({ ...props }) => (
  <TemplateContractsContextProvider>
    <View {...props} />
  </TemplateContractsContextProvider>
);

export default ContractsList;
